var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect5, _rect6, _path14, _line, _line2, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCabalAddBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 112,
    viewBox: "0 0 103 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.712402,
    y: 9.91406,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    fill: "#212327"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.712402,
    y: 9.91406,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    stroke: "#0B0B0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7963 30.9616C28.405 31.0409 27.5488 31.3529 26.8939 31.6548C26.2387 31.957 25.6039 32.2234 25.4831 32.2471C25.2303 32.297 24.2844 33.0714 23.5736 33.8102C23.3057 34.0888 22.7475 34.9956 22.3332 35.8254C21.601 37.2924 21.5801 37.3964 21.5801 39.5795C21.5801 41.977 21.7244 42.5073 22.9495 44.6145C23.262 45.1519 23.4563 45.6902 23.3813 45.811C23.3065 45.9318 23.3299 45.9784 23.4335 45.9146C23.6014 45.8112 26.6585 50.9392 26.5164 51.0855C26.4847 51.1179 26.6416 51.344 26.8652 51.588C27.0888 51.8318 27.5919 52.6502 27.9832 53.4068C28.3745 54.1634 28.7766 54.8416 28.8768 54.914C28.9768 54.9863 29.0008 55.1962 28.9298 55.3804C28.8581 55.5671 28.8853 55.6633 28.9916 55.5979C29.2142 55.4609 29.657 56.1871 29.4667 56.377C29.3962 56.4473 29.436 56.5048 29.5555 56.5048C29.8135 56.5048 30.6258 57.8205 30.6258 58.2388C30.6258 58.3996 30.6965 58.5311 30.7829 58.5311C30.8693 58.5311 31.1189 58.8732 31.3378 59.291C31.5565 59.709 32.0804 60.6223 32.502 61.321C32.9234 62.0194 33.2683 62.6369 33.2683 62.693C33.2683 62.7491 33.4913 63.1351 33.7641 63.5505C34.0367 63.9661 34.2883 64.4429 34.3231 64.6101C34.3579 64.7772 34.4418 64.9596 34.5095 65.0153C34.6801 65.1558 36.1493 67.597 36.5825 68.46C36.7782 68.8501 37.0248 69.306 37.1303 69.4732C37.6416 70.2831 38.96 72.5279 38.96 72.5884C38.96 72.6263 39.4302 73.4681 40.0048 74.4593C40.5795 75.4504 41.2525 76.6261 41.5007 77.0719C41.7489 77.5176 42.3839 78.6309 42.9122 79.546C43.4405 80.4608 43.8125 81.3066 43.7389 81.4254C43.6654 81.5439 43.7087 81.616 43.8351 81.5854C43.9615 81.5549 44.2967 81.9401 44.5797 82.4416C44.8626 82.9431 45.2232 83.5554 45.3812 83.8022C45.5389 84.049 45.668 84.3909 45.668 84.5621C45.668 84.7331 45.7402 84.8731 45.8286 84.8731C45.9168 84.8731 46.3512 85.5195 46.7941 86.3098C47.2369 87.0998 47.8176 88.1335 48.0849 88.6068C48.352 89.0799 48.8259 89.638 49.1377 89.8469C49.4495 90.0558 49.6717 90.2799 49.6314 90.3448C49.5369 90.4973 50.5956 90.6319 51.7925 90.6193C52.9375 90.6072 53.7967 90.0546 54.4374 88.918C54.6865 88.4765 54.9647 88.1152 55.056 88.1152C55.1473 88.1152 55.207 88.0469 55.1891 87.9632C55.1526 87.794 55.5164 86.9631 55.8321 86.4942C55.9447 86.327 56.6621 85.1193 57.4264 83.8107C58.1905 82.5019 58.8908 81.4989 58.9824 81.5818C59.0743 81.6645 59.0782 81.6098 58.9912 81.4598C58.8954 81.2951 59.0032 80.9579 59.2634 80.6067C59.5002 80.2876 59.6939 79.9865 59.6939 79.9377C59.6939 79.8888 60.0681 79.2345 60.5257 78.484C61.5219 76.8494 62.0055 76.0131 62.7934 74.5625C63.8458 72.6249 64.4922 71.69 64.6686 71.8499C64.7633 71.9358 64.7747 71.8914 64.6938 71.7514C64.6125 71.6108 64.7345 71.2339 64.9662 70.9096C65.1969 70.5867 65.3856 70.278 65.3856 70.2239C65.3856 70.1698 66.2088 68.7427 67.215 67.0528C68.2212 65.3628 69.0445 63.911 69.0445 63.8267C69.0445 63.7424 69.2098 63.4966 69.4116 63.2806C69.6135 63.0644 69.8011 62.7965 69.8283 62.6851C69.9745 62.0867 73.0624 57.1304 73.2071 57.2615C73.3013 57.3468 73.3218 57.3176 73.2527 57.1964C73.1836 57.0752 73.4891 56.3585 73.9316 55.6035C74.3741 54.8485 74.7362 54.1987 74.7362 54.1592C74.7362 54.1199 75.2393 53.2605 75.8542 52.2496C76.4691 51.2387 76.9722 50.3765 76.9722 50.3335C76.9722 50.2906 77.4295 49.5204 77.9885 48.6219C78.5475 47.7234 79.0049 46.9496 79.0049 46.9026C79.0049 46.8554 79.4623 46.042 80.0213 45.0953C80.5803 44.1484 81.0376 43.2228 81.0376 43.038C81.0376 42.8532 81.1096 42.7464 81.1976 42.8005C81.2856 42.8548 81.3785 41.88 81.4044 40.6342C81.445 38.6628 81.3858 38.1878 80.9472 36.9678C80.6701 36.1968 80.362 35.5129 80.2628 35.4481C80.1634 35.383 79.9666 35.1117 79.8255 34.8448C79.2803 33.8137 77.8782 32.5509 76.6349 31.9713C73.9397 30.7154 75.0856 30.7685 51.2662 30.7941C39.299 30.8068 29.1876 30.8822 28.7963 30.9616ZM48.1073 55.8933C48.1073 66.1484 48.0703 74.539 48.025 74.539C47.9294 74.539 45.9872 71.2701 45.9483 71.0436C45.9339 70.9599 45.8997 70.8233 45.8727 70.7396C45.8455 70.656 45.8363 70.5125 45.8522 70.4207C45.8682 70.3287 45.8014 70.3028 45.7036 70.3632C45.606 70.4233 45.3989 70.225 45.2434 69.9222C45.0879 69.6195 44.6956 68.916 44.3715 68.3587C42.215 64.6508 40.1796 61.104 40.1796 61.0539C40.1796 61.0215 39.719 60.2545 39.1561 59.3498C38.5858 58.4331 38.1953 57.5962 38.2739 57.4594C38.3518 57.3245 38.3402 57.2819 38.2485 57.3648C38.1566 57.4477 37.9818 57.3399 37.8601 57.1251C37.1517 55.8755 35.7426 53.4283 34.528 51.3378C34.0749 50.5576 33.6747 49.783 33.6387 49.6162C33.6027 49.4494 33.4626 49.2215 33.3275 49.1096C33.1925 48.9978 32.5634 47.9944 31.9296 46.8799C31.2957 45.7654 30.6103 44.58 30.4062 44.2457C29.2425 42.3387 27.9832 39.8841 27.9832 39.5226C27.9832 38.7641 28.3473 38.1321 29.0337 37.6985C29.6964 37.2799 29.9092 37.2703 38.9092 37.2592L48.1073 37.2476V55.8933ZM73.9387 38.2525C74.4386 38.7508 74.5329 39.0073 74.5329 39.8687C74.5329 40.8338 73.9495 42.2794 73.6716 42.0026C73.6086 41.9397 73.571 42.0107 73.5877 42.16C73.6293 42.5308 69.5952 49.4002 69.4047 49.2829C69.3209 49.2312 69.299 49.3102 69.3561 49.4584C69.413 49.6065 69.2291 50.0391 68.9471 50.42C68.6654 50.801 68.4347 51.1757 68.4347 51.2531C68.4347 51.556 66.2594 55.0816 66.1316 54.9857C66.0566 54.9296 66.0375 54.9409 66.0891 55.011C66.1405 55.081 65.9686 55.514 65.7069 55.9735C65.0766 57.0797 63.3916 59.971 63.1534 60.3548C63.0497 60.522 62.26 61.8898 61.3985 63.3943C58.2858 68.8309 57.404 70.2837 57.2174 70.2837C57.1129 70.2837 57.0694 70.352 57.1211 70.4357C57.1727 70.5194 56.9956 70.9524 56.7279 71.3982C56.46 71.844 56.1771 72.3455 56.0988 72.5127C56.0205 72.6798 55.6542 73.3181 55.2849 73.9311L54.6131 75.0455L54.6127 56.3529L54.6121 37.6602H63.9783H73.3445L73.9387 38.2525Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.966625,
    y: 1.1175,
    width: 101.066,
    height: 101.066,
    rx: 50.5329,
    fill: "#373C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.966625,
    y: 1.1175,
    width: 101.066,
    height: 101.066,
    rx: 50.5329,
    stroke: "#0B0B0B",
    strokeWidth: 1.50844
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0419 22.6907C39.951 22.9095 64.5484 21.7571 64.8777 22.6907C65.1527 23.6242 64.8235 28.0169 63.9984 28.565C61.9124 29.9924 59.9912 31.4198 58.618 32.7369C60.3204 35.9752 62.846 39.5447 65.5904 43.1685C70.9709 50.4703 86.3433 62.2751 76.0221 75.2865C72.838 79.2396 68.5015 81.3797 63.3941 81.3797H38.4694C33.4182 81.3797 29.0255 79.2376 25.8976 75.2865C15.5221 62.2751 30.9488 50.4703 36.3292 43.1685C39.0194 39.5447 41.545 35.9771 43.2475 32.7369C41.8743 31.4198 39.9529 29.9924 37.867 28.565C36.8231 27.8503 36.4938 22.6907 37.0419 22.6907Z",
    fill: "#AE7A00",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2475 29.334H47.0901H50.9327H54.7753H58.618C60.3204 32.5723 62.846 36.1419 65.5904 39.7656C70.9709 47.0674 86.3433 58.8722 76.0221 71.8836C72.838 75.8909 68.5015 77.9768 63.3941 77.9768C55.1046 77.9768 46.8131 77.9768 38.4694 77.9768C33.4182 77.9768 29.0255 75.8909 25.8976 71.8836C15.5221 58.8722 30.9488 47.0674 36.3292 39.7656C39.0194 36.1419 41.545 32.5723 43.2475 29.334Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2477 29.3354H58.6201C59.9933 28.0183 61.9147 26.5909 64.0006 25.1635C64.8237 24.6154 65.153 23.6257 64.8799 22.6921C64.5507 21.7586 63.7275 21.1543 62.7378 21.1543H39.1301C38.1423 21.1543 37.3192 21.7586 37.0441 22.6921C36.7149 23.6257 37.0441 24.6134 37.8673 25.1635C39.9532 26.589 41.8745 28.0164 43.2477 29.3354Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2715 32.7383H52.0866",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8706 32.7383H60.6468",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6011 77.9785V81.3815",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6919 77.9785V81.3815",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5196 42.1582V41.839H53.2003H49.3675H49.0483V42.1582V45.8544H45.5376H45.2184V46.1736V58.214V58.5333H45.5376H52.8811V61.9043H45.5376H45.2184V62.2235V66.2419V66.5611H45.5376H49.0483V70.2514V70.5706H49.3675H53.2003H53.5196V70.2514V66.5611H57.0303H57.3495V66.2419V54.1954V53.8762H57.0303H49.6867V50.5052H57.0303H57.3495V50.1859V46.1735V45.8542H57.0303H53.5196V42.1582Z",
    fill: "#595E65",
    stroke: "#0B0B0B",
    strokeWidth: 0.638482
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6269 67.3965C66.3909 67.3965 62.1392 71.6482 62.1392 76.8842C62.1392 82.1202 66.3909 86.3719 71.6269 86.3719C76.8628 86.3719 81.1146 82.1202 81.1146 76.8842C81.1146 71.6482 76.8628 67.3965 71.6269 67.3965Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6269 65.1465C66.3909 65.1465 62.1392 69.3982 62.1392 74.6342C62.1392 79.8702 66.3909 84.1219 71.6269 84.1219C76.8628 84.1219 81.1146 79.8702 81.1146 74.6342C81.1146 69.3982 76.8628 65.1465 71.6269 65.1465Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6091 68.625H70.6419C70.0445 68.625 69.5524 69.1171 69.5524 69.7146V72.5607H66.7063C66.1088 72.5607 65.6167 73.0528 65.6167 73.6502V75.6174C65.6167 76.2149 66.1088 76.707 66.7063 76.707H69.5524V79.5531C69.5524 80.1506 70.0445 80.6427 70.6419 80.6427H72.6091C73.2066 80.6427 73.6987 80.1506 73.6987 79.5531V76.707H76.5448C77.1423 76.707 77.6344 76.2149 77.6344 75.6174V73.6502C77.6344 73.0528 77.1423 72.5607 76.5448 72.5607H73.6987V69.7146C73.6987 69.1171 73.2066 68.625 72.6091 68.625Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8334 83.3125L67.6934 85.1743",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.712402,
    y: 0.863281,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    fill: "#373C44"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.712402,
    y: 0.863281,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    stroke: "#0B0B0B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0654 65.75H71.935V70.1739C71.935 74.7723 68.2073 78.5 63.6089 78.5H38.3915C33.7932 78.5 30.0654 74.7723 30.0654 70.1739V65.75Z",
    fill: "#AE7A00",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    y1: 72.2617,
    x2: 38.5,
    y2: 78.2617,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.5,
    y1: 72.2617,
    x2: 64.5,
    y2: 78.2617,
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9565 48.5H74.4565V49V65.25V65.75H74.9565H76.2174C78.5787 65.75 80.5 63.8515 80.5 61.5V52.75C80.5 50.3985 78.5787 48.5 76.2174 48.5H74.9565Z",
    fill: "#212327",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0435 48.5H27.5435V49V65.25V65.75H27.0435H25.7826C23.4213 65.75 21.5 63.8515 21.5 61.5V52.75C21.5 50.3985 23.4213 48.5 25.7826 48.5H27.0435Z",
    fill: "#212327",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7611 34V34.5H52.2611H64.8698C68.7762 34.5 71.935 37.6377 71.935 41.5V65.25C71.935 69.1123 68.7762 72.25 64.8698 72.25H37.1306C33.2242 72.25 30.0654 69.1123 30.0654 65.25V41.5C30.0654 37.6377 33.2242 34.5 37.1306 34.5H49.7393H50.2393V34V27.5462V27.1732L49.8817 27.0669C48.2633 26.5863 47.0872 25.1198 47.0872 23.375C47.0872 21.239 48.835 19.5 51.0002 19.5C53.1654 19.5 54.9133 21.239 54.9133 23.375C54.9133 25.1198 53.7371 26.5863 52.1187 27.0669L51.7611 27.1732V27.5462V34ZM59.3686 62.5068L59.3687 62.5067C60.2342 62.0655 60.5779 61.0097 60.1316 60.1476L60.1313 60.1469C59.6849 59.2881 58.6246 58.9519 57.7625 59.3906L57.7622 59.3908C53.5737 61.5256 48.4267 61.5256 44.2383 59.3908L44.2372 59.3902C43.373 58.9523 42.3141 59.2893 41.869 60.1473L41.8686 60.148C41.4224 61.0116 41.768 62.0655 42.6313 62.5065L42.6318 62.5068C45.1934 63.8119 48.0869 64.5 51.0002 64.5C53.9135 64.5 56.807 63.8119 59.3686 62.5068ZM42.8046 43.5C40.0952 43.5 37.8915 45.6785 37.8915 48.375C37.8915 51.0715 40.0952 53.25 42.8046 53.25C45.5139 53.25 47.7176 51.0715 47.7176 48.375C47.7176 45.6785 45.5139 43.5 42.8046 43.5ZM54.2828 48.375C54.2828 51.0715 56.4865 53.25 59.1959 53.25C61.9052 53.25 64.1089 51.0715 64.1089 48.375C64.1089 45.6785 61.9052 43.5 59.1959 43.5C56.4865 43.5 54.2828 45.6785 54.2828 48.375Z",
    fill: "#FFC949",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1955 50.75C60.5121 50.75 61.5868 49.6907 61.5868 48.375C61.5868 47.0593 60.5121 46 59.1955 46C57.8789 46 56.8042 47.0593 56.8042 48.375C56.8042 49.6907 57.8789 50.75 59.1955 50.75Z",
    fill: "#FFC949",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8044 50.75C44.121 50.75 45.1957 49.6907 45.1957 48.375C45.1957 47.0593 44.121 46 42.8044 46C41.4878 46 40.4131 47.0593 40.4131 48.375C40.4131 49.6907 41.4878 50.75 42.8044 50.75Z",
    fill: "#FFC949",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9565 44.75H74.4565V45.25V61.5V62H74.9565H76.2174C78.5787 62 80.5 60.1015 80.5 57.75V49C80.5 46.6485 78.5787 44.75 76.2174 44.75H74.9565Z",
    fill: "#595E65",
    stroke: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5435 45.25V44.75H27.0435H25.7826C23.4213 44.75 21.5 46.6485 21.5 49V57.75C21.5 60.1015 23.4213 62 25.7826 62H27.0435H27.5435V61.5V45.25Z",
    fill: "#595E65",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCabalAddBot);
export default __webpack_public_path__ + "static/media/create-cabal-add-bot.a1f37e5a7f813cb6c5dcc4ec65bb9e81.svg";
export { ForwardRef as ReactComponent };